import React from "react";
import "./NewCollections.css";
import NewCollection_Data from "../Assets/new_collections";
import Item from "../Items/Item";

const NewCollections = () => {
  return (
    <div className="NewCollections">
      <h1>NEW COLLECTIONS</h1>
      <hr />
      <div className="collections">
        {NewCollection_Data.map((item, i) => {
          return (
            <Item
              key={i}
              img={item.image}
              name={item.name}
              new_price={item.new_price}
              old_price={item.old_price}
            />
          );
        })}
      </div>
    </div>
  );
};

export default NewCollections;
